import React, { useContext } from "react";

import { Button, Icon, PlainButton, Tooltip } from "@culturehq/components";

import { Trans, t } from "app/utils";

import VideoStudioModalButton from "./common/VideoStudioModalButton";
import VideoStudioIcon from "../../common/icons/VideoStudioIcon";
import { CreatomateContext, CustomButtonType } from "./contexts/VideoStudioContext";

interface TriggerButtonProps {
  CustomButton?: CustomButtonType;
  disabled?: boolean;
  justIcon?: boolean;
  onOpenModal: () => void;
  onPauseVideo?: (value?: boolean) => void;
}

const TriggerButton: React.FC<TriggerButtonProps> = ({
  CustomButton,
  disabled,
  justIcon,
  onOpenModal,
  onPauseVideo
}) => {
  const { data } = useContext(CreatomateContext);
  const { mediaType, montage } = data;

  const onOpen = () => {
    if (onPauseVideo) onPauseVideo();

    onOpenModal();
  };

  const handleOpenModal = () => {
    if (disabled) return;
    onOpenModal();
  };

  if (CustomButton) {
    return <CustomButton onClick={handleOpenModal} />;
  }

  if (montage) {
    return (
      <PlainButton
        className={`stories-video-editor-btn ${disabled ? "btn disabled" : ""}`}
        disabled={disabled}
        onClick={handleOpenModal}
      >
        <Icon icon="ios-plus" />
        <Trans>Create Montage</Trans>
      </PlainButton>
    );
  }

  return (
    <>
      {justIcon ? (
        <Button className="VideoStudio-Btn" onClick={onOpen} disabled={disabled}>
          <VideoStudioIcon />
        </Button>
      ) : (
        <>
          {disabled ? (
            <Tooltip tip={t("You'll be able to edit your video in a moment once it finishes buffering.")}>
              <VideoStudioModalButton
                disabled={disabled}
                mediaType={mediaType}
                onOpen={onOpen}
              />
            </Tooltip>
          ) : (
            <VideoStudioModalButton
              disabled={disabled}
              mediaType={mediaType}
              onOpen={onOpen}
            />
          )}
        </>
      )}
    </>
  );
};

export default TriggerButton;
